import React, { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const STORAGE_KEY = "snackbarSeenBan";

export default function OICSnackbar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      localStorage.setItem(STORAGE_KEY, "true");
      setOpen(true);
    }
  }, []);

  const handleClose = () => setOpen(false);

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={open}
      onClose={handleClose}
      ContentProps={{
        sx: {
          flexWrap: "nowrap",
          alignItems: "center",
        },
      }}
      message={
        <Typography variant="body2">
          ATTENTION: Firearms tagged with &quot;OIC&quot; have been
          partially or wholly prohibited by the 2020, 2024 or 2025 OICs.
        </Typography>
      }
      action={
        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    />
  );
}
